import React, { useState, useEffect } from "react";
import { Redirect } from 'react-router-dom'
import SubPageTemplate from "./templates/SubPageTemplate";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import PastSeason from "../components/pastseason";

import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Dropdown from "../components/inputs/Dropdown";
import ActionButton from '../components/inputs/ActionButton';

import {
  profileAPI,
  headerAPI,
  rankingAPI,
  _link,
  prefixURI,
  seasonDisplayName
} from "../common/utilities";
import styles from "./RankedStatsPage.module.scss";
import { Container } from "@material-ui/core";


export default function RankedStatsPage(props) {
  const { match, devUSN } = props;

  const { t, i18n } = useTranslation();

  // const [usn, setUSN] = useState();
  const [headerData, setHeaderData] = useState();
  const [seasons, setSeasons] = useState();
  const [orderedSeasonsIDs, setOrderedSeasonsIDs] = useState();
  const [selectedIndex, setSelectedIndex] = useState();
  const [pageStatus, setPageStatus] = useState(true);
  const [pogData, setPogData] = useState(null);
  const [pogRankingAPIData, setPogRankingAPIData] = useState(0);

  const usn = devUSN ? devUSN : match ? match.params.usn : null;

  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('xs'));

  var prevButtonText = (mobileView) ? t('Prev') : t('Previous Season'); // -- should be (could be shortened?) on xs devices
  var nextButtonText = (mobileView) ? t('Next') : t('Next Season');

  var pageTitle1 = t("Ranked Statistics History");
  var pageTitle  = t(
    'Ranked Statistics History of {{ign}} - Crossfire Player Profile',
    { ign: headerData ? headerData.NICK : "" }
  );

  // get and set Path of Glory Data
  // {CDN}/assets/js/ranking/season_data.js
  useEffect(() => {

    let TIER_STAGE8_COUNT = 0;

    try{
      if(window.seasonRankingData){
        setPogData(window.seasonRankingData);
        console.log('got global POG data');
        console.log(window.seasonRankingData);
      }else{
        setPogData([]);
      }
    }catch(e){
      console.log(e);
      console.log('did not get global POG data');
      setPogData([]);
    }

    try{
      axios.get(`${rankingAPI}`).then(res => {
        if(res.data.APIresult === '000' && res.data.ds_WEB_USER_ALLTIME_POG_Total && res.data.ds_WEB_USER_ALLTIME_POG_Total[0] && res.data.ds_WEB_USER_ALLTIME_POG_Total[0].glory_total){
          TIER_STAGE8_COUNT = res.data.ds_WEB_USER_ALLTIME_POG_Total[0].glory_total;
          setPogRankingAPIData(res.data.ds_WEB_USER_ALLTIME_POG_Total[0].glory_total);
        }else{
          setPogRankingAPIData(0);
        }
      });
    }catch(e){
      setPogRankingAPIData(0);
    }
  }, []);

  // Similar to componentDidMount and componentDidUpdate:
  //
  // https://stackoverflow.com/questions/53120972/how-to-call-loading-function-with-react-useeffect-only-once
  useEffect(() => {
    //api call to set data will be used

    let TIER_STAGE8_COUNT = 0;

    if (usn) {
      axios.get(`${headerAPI}&usn=${usn}`).then(res => {
        if(res.data.p_o_ErrID === 1)
          setHeaderData(res.data.dsProfileHeaderInfo[0]);
        else
          setPageStatus(false);
      });

      axios.get(`${profileAPI}?usn=${usn}&command=rankedstats`).then(res => {
        //build ranked seasons obj
        let sObj = [];

        for (let item of res.data.dsRankedStatsResult) {
          if (!sObj.hasOwnProperty(`${item.PARTKEY_SEASON_NO}`)) {
            sObj[parseInt(item.PARTKEY_SEASON_NO,10)] = [];
          }

          if(pogData
            && pogData[parseInt(item.PARTKEY_SEASON_NO,10)]
            && pogData[parseInt(item.PARTKEY_SEASON_NO,10)].POGTotal){
              item.TIER_STAGE8_COUNT = pogData[parseInt(item.PARTKEY_SEASON_NO,10)].POGTotal;
              //console.log('found ' + item.TIER_STAGE8_COUNT + ' as POG total for season: ' + item.PARTKEY_SEASON_NO);
          }else{
            //console.log ('no pog data for season: ' + item.PARTKEY_SEASON_NO);
            item.TIER_STAGE8_COUNT = pogRankingAPIData;
          }

          //console.log('sending pogdata: ' + item.TIER_STAGE8_COUNT + ' for season ' + item.PARTKEY_SEASON_NO);
          sObj[parseInt(item.PARTKEY_SEASON_NO,10)].push(item);

          // create select options
          sObj[parseInt(item.PARTKEY_SEASON_NO,10)].label = t('Season {{x}}', { x: seasonDisplayName(parseInt(item.PARTKEY_SEASON_NO,10)) });;
          sObj[parseInt(item.PARTKEY_SEASON_NO,10)].value = parseInt(item.PARTKEY_SEASON_NO,10);
        }

        // display seasons from most recent to oldest
        sObj = sObj.reverse();

        setSeasons(sObj);
        setOrderedSeasonsIDs(Object.keys(sObj).sort(sortNumber));
        setSelectedIndex(0);
      });
    }
  }, [pogData, pogRankingAPIData]);

  if (seasons == null ||
    orderedSeasonsIDs == null ||
    selectedIndex == null) {
      //console.log('no data, go to the error page');
    return null;
  }

  let selectedSeason = orderedSeasonsIDs[selectedIndex];

  //console.log('currentSeason', seasons[selectedSeason].value);
  //console.log(selectedSeason);
  //console.log(seasons[selectedSeason][0].PARTKEY_SEASON_NO);


  // this function was created because the dropdown callback sends the season value, not the array's index
  const dropDownCallback = value => {

      //console.log('dropDownCallback', value);
      // find the index of the season
      for(var j in seasons){

        //console.log('index testing', j, 'vs', seasons[j].label);

        if(value == seasons[j].value){
          //console.log('index found', j);

          if(orderedSeasonsIDs[j]){
            //console.log('index found', j, orderedSeasonsIDs[j])
            setSelectedIndex(j);
            //console.log('selectedSeason: ', selectedSeason, 'j is: ', j)
            //setSeasonIndexField(getSeasonIndexField(j));
            return;
          }
        }
      }
  }

  function getCurrentSeason(){
    return seasons[selectedSeason].value;
  }

// display the season info from the object, not the array index
function getSeasonIndexField(selectedSeason){

  //console.log('getSeasonIndexField: got: ' + selectedSeason)

  var index = 0; //latest season since the array is reversed
  if(seasons && seasons[selectedSeason][0]){
    index = seasons[selectedSeason][0].PARTKEY_SEASON_NO;

    //console.log('getSeasonIndexField: show season: ' + index)
    //setSelectedIndex(index);
  }
  return index;
}

// Proper numeric sort, because well, you know, javascript (most times has "no idea" what a number is)
// plain javascript sort	: ["0", "1", "10", "2", "3", "4", "5", "6", "7", "8", "9"]
// with sortNumber			: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
function sortNumber(a, b) {
  return a - b;
}

  // output seasons

  // null object for season data in the case (many cases) where there is no data
  var nullData = {
    PARTKEY_SEASON_NO: ''
    ,MODE_NO_DESC: ''
    ,RANK_SCORE: null
    ,RANKING: null
    ,WIN: null
    ,LOSE: null
    ,MATCH_COUNT: null
    ,KILL: null
    ,DEATH: null
    ,TIER_GROUP_ID: null
    ,TIER_GROUP_NAME: null
    ,TIER_STAGE_ID: null
    ,TIER_STAGE8_COUNT: null
  };

  const seasonOutput = seasons[`${selectedSeason}`].map(function(data, index){

    if(data && data.PARTKEY_SEASON_NO){
        // check for TIER_STAGE8_COUNT
        //
    }else{
        data = nullData;
    }

    return (
      <Grid item xs={12} sm={6} md={6} lg={3} xl={3} key={index}>
          <PastSeason
                    key={index}
                    seasonNo={data.PARTKEY_SEASON_NO}
                    mode={data.MODE_NO_DISPLAY_NAME}
                    rank_score={data.RANK_SCORE}
                    ranking={data.RANKING}
                    win={data.WIN}
                    lose={data.LOSE}
                    games={data.MATCH_COUNT}
                    kill={data.KILL}
                    death={data.DEATH}
                    tier_id={data.TIER_GROUP_ID}
                    tier_name={data.TIER_GROUP_NAME}
                    tier_stage={data.TIER_STAGE_ID}
                    TIER_STAGE8_COUNT={data.TIER_STAGE8_COUNT}
                />
      </Grid>

    );
  })

  const seasonNav = <Grid className={styles.rankedStatsNav}
                        direction="row"
                        container
                        spacing={2}
                        justify="space-between"
                        alignItems="center"
                      >
                      <Grid item xs><ActionButton onClick={() => dropDownCallback(getCurrentSeason() - 1)}>{prevButtonText}</ActionButton></Grid>
                      <Grid item xs={6} sm={3} md={2} lg={2} xl={2}><Dropdown options={seasons} onChange={dropDownCallback} selectedValue={getSeasonIndexField(selectedIndex)} /></Grid>
                      <Grid item xs><ActionButton style={{float: 'right'}} onClick={() => dropDownCallback(getCurrentSeason() + 1)}>{nextButtonText}</ActionButton></Grid>

                    </Grid>

  return (
    <SubPageTemplate
      title={pageTitle}
      headerData={headerData}
      headingLeft={pageTitle1}
    >
      {!pageStatus ? <Redirect to={`${prefixURI}/error`} /> : null}
      <div className={styles.page_content}>
          <div
            container
            spacing={3}
            alignItems="center"
            className={styles.rankedStatsPage}
          >
            <div>{seasonNav}</div>
              <div style={{margin: '0', padding: '0 8px'}}>
                <Grid container spacing={2}>
                  {seasonOutput}
                </Grid>
              </div>
              <div>{seasonNav}</div>
          </div>
      </div>
    </SubPageTemplate>
  );
}